import compose from 'recompose/compose'

import withQueryDateState from './withQueryDateState'

import CustExchanger from './CustExchanger'


export default compose(
  withQueryDateState
)(CustExchanger)



// WEBPACK FOOTER //
// ./src/components/CustExchanger/index.js